jQuery(document).ready(function onMiscReady($) {
    $('.std-puff__content').matchHeight();

    $('.equal').matchHeight();

    $(document).bind('gform_confirmation_loaded', onGFormConfirmationLoaded);

    function onGFormConfirmationLoaded(event, formId) {
        $('.guide-select').each(function() {
            var $this = $(this);
            var checked = $this.attr('checked');
            if (checked === 'checked') {
                var file = $this.data('file');
                $('.guide-form').append('<a href="' + file + '" target="_blank"> Ladda ned guide</a>');
            }
        });
    }

    $(".play-button").on('click', function() {
        var $this = $(this);
        var video = $this.parent().find('iframe');
        video.vimeo('play');
        $this.fadeOut();
        $this.parent().addClass('playing')
    });

    $(".pause-button").on('click', function() {
        var $this = $(this);
        var video = $this.parent().find('iframe');
        video.vimeo('pause');
        $this.parent().find('.play-button').fadeIn()
        $this.parent().removeClass('playing')
    });

    var winWidth = $(window).width();

    if (winWidth <= 911) {
        new Swiper('.mobile-swiper-container', {
            autoHeight: true,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
        });
    }

    if (document.getElementById('gallery-strip-swiper')) {
        new Swiper('#gallery-strip-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true,
            grabCursor: true,
        });
    }

    if (document.getElementById('mobile-gallery-swiper')) {
        new Swiper('#mobile-gallery-swiper', {
            slidesPerView: 1,
            loop: true,
            pagination: {
                el: '.mobile-gallery__pagination',
                clickable: true,
            },
        });
    }

    jQuery("#js-rotating").Morphext({
        animation: "fadeIn",
        before: function(phrase) {
            var container = document.createElement('span');
            var text = document.createTextNode(phrase);
            container.appendChild(text);
            container.setAttribute('class', 'morphext__width-checker');
            document.body.appendChild(container);

            var width = jQuery(container).innerWidth();

            container.parentElement.removeChild(container);
            jQuery('.morphext').css('width', width);
        }
    });

});
